module.exports = __webpack_public_path__ + "img/evaluation_icon.55a26da6.svg";